// extracted by mini-css-extract-plugin
export default {"uw_mainRowHolder":"userwriting_uw_mainRowHolder__sqQ7+","procedure":"userwriting_procedure__toOYp"};